/* Product information tabs.
 *
 * Moves the panel strip by whole panels. The transform lives in a custom
 * property so the CSS owns the animation and this only owns the index.
 */
(function () {
  'use strict';

  function setup(section) {
    var panels = section.querySelector('[data-resemble-story-panels]');
    var tabs = section.querySelectorAll('[data-resemble-story-tab]');
    if (!panels || !tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-resemble-story-tab');
        panels.style.setProperty('--resemble-story-index', index);
        tabs.forEach(function (other) {
          var active = other === tab;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-resemble-story]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-resemble-story]');
    if (section) setup(section);
  });
})();
